export default "__VITE_ASSET__B5fiPwTI__$_?format=webp__"